import intro01T2 from "./Introduccion/Intro-01.mp3";
import intro02T2 from "./Introduccion/Intro-02.mp3";

import sub1_act1_a01T2 from "./Subtema_1/T2-Sub 1- Act 1-A01.mp3";
import sub1_act2_a01T2 from "./Subtema_1/T2-Sub 1- Act 2-A01.mp3";
import sub1_act2_a02T2 from "./Subtema_1/T2-Sub 1- Act 2-A02.mp3";
import sub1_act3_a01T2 from "./Subtema_1/T2-Sub 1- Act 3-A01.mp3";
import sub1_act3_a02T2 from "./Subtema_1/T2-Sub 1- Act 3-A02.mp3";

//* sub 2
import sub2_act1_a01T2 from "./Subtema_2/T2-Sub 2- Act 1-A01.mp3";
import sub2_act1_a02T2 from "./Subtema_2/T2-Sub 2- Act 1-A02.mp3";

import sub2_act2_a01T2 from "./Subtema_2/T2-Sub 2- Act 2-A01.mp3";
import sub2_act2_a02T2 from "./Subtema_2/T2-Sub 2- Act 2-A02.mp3";

import sub2_act3_a01T2 from "./Subtema_2/T2-Sub 2- Act 3-A01.mp3";
import sub2_act3_a02T2 from "./Subtema_2/T2-Sub 2- Act 3-A02.mp3";
import sub2_act3_a03T2 from "./Subtema_2/T2-Sub 2- Act 3-A03.mp3";
import sub2_act3_a04T2 from "./Subtema_2/T2-Sub 2- Act 3-A04.mp3";
import sub2_act3_a05T2 from "./Subtema_2/T2-Sub 2- Act 3-A05.mp3";
import sub2_act3_a06T2 from "./Subtema_2/T2-Sub 2- Act 3-A06.mp3";
import sub2_act3_a07T2 from "./Subtema_2/T2-Sub 2- Act 3-A07.mp3";
import sub2_act3_a08T2 from "./Subtema_2/T2-Sub 2- Act 3-A08.mp3";
import sub2_act3_a09T2 from "./Subtema_2/T2-Sub 2- Act 3-A09.mp3";
import sub2_act3_a10T2 from "./Subtema_2/T2-Sub 2- Act 3-A10.mp3";

import sub2_act4_a01T2 from "./Subtema_2/T2-Sub 2- Act 4-A01.mp3";
import sub2_act4_a02T2 from "./Subtema_2/T2-Sub 2- Act 4-A02.mp3";
import sub2_act4_a03T2 from "./Subtema_2/T2-Sub 2- Act 4-A03.mp3";
import sub2_act4_a04T2 from "./Subtema_2/T2-Sub 2- Act 4-A04.mp3";
import sub2_act4_a05T2 from "./Subtema_2/T2-Sub 2- Act 4-A05.mp3";
import sub2_act4_a06T2 from "./Subtema_2/T2-Sub 2- Act 4-A06.mp3";
import sub2_act4_a07T2 from "./Subtema_2/T2-Sub 2- Act 4-A07.mp3";
import sub2_act4_a08T2 from "./Subtema_2/T2-Sub 2- Act 4-A08.mp3";
import sub2_act4_a09T2 from "./Subtema_2/T2-Sub 2- Act 4-A09.mp3";
import sub2_act4_a10T2 from "./Subtema_2/T2-Sub 2- Act 4-A10.mp3";
import sub2_act4_a11T2 from "./Subtema_2/T2-Sub 2- Act 4-A11.mp3";
import sub2_act4_a12T2 from "./Subtema_2/T2-Sub 2- Act 4-A12.mp3";
import sub2_act4_a13T2 from "./Subtema_2/T2-Sub 2- Act 4-A13.mp3";
import sub2_act4_a14T2 from "./Subtema_2/T2-Sub 2- Act 4-A14.mp3";
import sub2_act4_a15T2 from "./Subtema_2/T2-Sub 2- Act 4-A15.mp3";
import sub2_act4_a16T2 from "./Subtema_2/T2-Sub 2- Act 4-A16.mp3";
import sub2_act4_a17T2 from "./Subtema_2/T2-Sub 2- Act 4-A17.mp3";
import sub2_act4_a18T2 from "./Subtema_2/T2-Sub 2- Act 4-A18.mp3";

import sub2_act5_a01T2 from "./Subtema_2/T2-Sub 2- Act 5-A01.mp3";
import sub2_act5_a02T2 from "./Subtema_2/T2-Sub 2- Act 5-A02.mp3";
import sub2_act5_a03T2 from "./Subtema_2/T2-Sub 2- Act 5-A03.mp3";
import sub2_act5_a04T2 from "./Subtema_2/T2-Sub 2- Act 5-A04.mp3";
import sub2_act5_a05T2 from "./Subtema_2/T2-Sub 2- Act 5-A05.mp3";
import sub2_act5_a06T2 from "./Subtema_2/T2-Sub 2- Act 5-A06.mp3";
import sub2_act5_a07T2 from "./Subtema_2/T2-Sub 2- Act 5-A07.mp3";
import sub2_act5_a08T2 from "./Subtema_2/T2-Sub 2- Act 5-A08.mp3";
import sub2_act5_a09T2 from "./Subtema_2/T2-Sub 2- Act 5-A09.mp3";
import sub2_act5_a10T2 from "./Subtema_2/T2-Sub 2- Act 5-A10.mp3";
import sub2_act5_a11T2 from "./Subtema_2/T2-Sub 2- Act 5-A11.mp3";

import sub2_act6_a01T2 from "./Subtema_2/T2-Sub 2- Act 6-A01.mp3";
import sub2_act6_a02T2 from "./Subtema_2/T2-Sub 2- Act 6-A02.mp3";
import sub2_act6_a03T2 from "./Subtema_2/T2-Sub 2- Act 6-A03.mp3";
import sub2_act6_a04T2 from "./Subtema_2/T2-Sub 2- Act 6-A04.mp3";
import sub2_act6_a05T2 from "./Subtema_2/T2-Sub 2- Act 6-A05.mp3";
import sub2_act6_a06T2 from "./Subtema_2/T2-Sub 2- Act 6-A06.mp3";
import sub2_act6_a07T2 from "./Subtema_2/T2-Sub 2- Act 6-A07.mp3";
import sub2_act6_a08T2 from "./Subtema_2/T2-Sub 2- Act 6-A08.mp3";
import sub2_act6_a09T2 from "./Subtema_2/T2-Sub 2- Act 6-A09.mp3";

import sub2_act7_a01T2 from "./Subtema_2/T2-Sub 2- Act 7-A01.mp3";

import sub2_act8_a01T2 from "./Subtema_2/T2-Sub 2- Act 8-A01.mp3";
import sub2_act8_a02T2 from "./Subtema_2/T2-Sub 2- Act 8-A02.mp3";


export const T2_voices = {
	introduccion: {
		intro01T2,
		intro02T2,
	},
	sub01: {
		sub1_act1_a01T2,
		sub1_act2_a01T2,
		sub1_act2_a02T2,
		sub1_act3_a01T2,
		sub1_act3_a02T2,
	},
	sub02: {
		sub2_act1_a01T2,
		sub2_act1_a02T2,
		sub2_act2_a01T2,
		sub2_act2_a02T2,
		sub2_act3_a01T2,
		sub2_act3_a02T2,
		sub2_act3_a03T2,
		sub2_act3_a04T2,
		sub2_act3_a05T2,
		sub2_act3_a06T2,
		sub2_act3_a07T2,
		sub2_act3_a08T2,
		sub2_act3_a09T2,
		sub2_act3_a10T2,
		sub2_act4_a01T2,
		sub2_act4_a02T2,
		sub2_act4_a03T2,
		sub2_act4_a04T2,
		sub2_act4_a05T2,
		sub2_act4_a06T2,
		sub2_act4_a07T2,
		sub2_act4_a08T2,
		sub2_act4_a09T2,
		sub2_act4_a10T2,
		sub2_act4_a11T2,
		sub2_act4_a12T2,
		sub2_act4_a13T2,
		sub2_act4_a14T2,
		sub2_act4_a15T2,
		sub2_act4_a16T2,
		sub2_act4_a17T2,
		sub2_act4_a18T2,
		sub2_act5_a01T2,
		sub2_act5_a02T2,
		sub2_act5_a03T2,
		sub2_act5_a04T2,
		sub2_act5_a05T2,
		sub2_act5_a06T2,
		sub2_act5_a07T2,
		sub2_act5_a08T2,
		sub2_act5_a09T2,
		sub2_act5_a10T2,
		sub2_act5_a11T2,
		sub2_act6_a01T2,
		sub2_act6_a02T2,
		sub2_act6_a03T2,
		sub2_act6_a04T2,
		sub2_act6_a05T2,
		sub2_act6_a06T2,
		sub2_act6_a07T2,
		sub2_act6_a08T2,
		sub2_act6_a09T2,
		sub2_act7_a01T2,
		sub2_act8_a01T2,
		sub2_act8_a02T2,
	},
};
